import {
  Booking,
  CompleteBooking,
  CreateBookingDTO,
  UpdateBookingDTO,
} from "../types/Booking";
import { Sport } from "../types/Sport";
import client from "./axios";

const baseUrl = "https://internal-api.getmoveapp.com/api/v1/admin/bookings";
//const baseUrl = "http://localhost:3000/api/v1/admin/bookings";
const facilitiesUrl =
  "https://internal-api.getmoveapp.com/api/v1/admin/facilities";
//const facilitiesUrl = "http://localhost:3000/api/v1/admin/facilities";
//const bookingUrl = `http://localhost:3000/api/v1/bookings`;
const bookingUrl = `https://internal-api.getmoveapp.com/api/v1/bookings`;

export const Bookings = {
  getUserBooking: () => client.get<{ list: CompleteBooking[] }>(`${baseUrl}`),
  deleteBooking: (id: string) =>
    client.delete<{ result: string }>(`${baseUrl}/${id}`),
  getBooking: (id: string) =>
    client.get<{ booking: CompleteBooking }>(`${baseUrl}/${id}`),
  getUserSports: () => client.get<{ list: Sport[] }>(`${facilitiesUrl}`),
  getAdminBookings: (sportId: number, date: string) =>
    client.get<{ list: any[] }>(`${facilitiesUrl}/${sportId}/bookings/${date}`),
  createBooking: (body: CreateBookingDTO) =>
    client.post<{ booking: Booking }>(`${bookingUrl}/create`, body),
  createBulkBookings: (body: any) =>
    client.post<{ booking: Booking }>(`${bookingUrl}/create-bulk`, body),
  updateBooking: (bookingId: string, body: UpdateBookingDTO) =>
    client.put(`${bookingUrl}/${bookingId}`, body),
};
